export default "__VITE_ASSET__DyajB_w8__"